import { Map } from "mapbox-gl";

export function paintCircles(
  map: Map,
  layer: string,
  fill: string,
  stroke: string
) {
  map.setPaintProperty(layer, "circle-stroke-width", 1);
  map.setPaintProperty(layer, "circle-color", fill);
  map.setPaintProperty(layer, "circle-stroke-color", stroke);
}
